/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { useEffect, useState } from 'react';
import usageTracker from '../../lib/usageTracker';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import AlertMessage from '../AlertMessage';
import Logo from '../Logo';
import HomepageForm from '../HomepageForm';
import LanguageSwitcher from '../LanguageSwitcher';
import DocumentHead from '../portals/DocumentHead';
import Canonical from '../Canonical';
import Hreflang from '../Hreflang';
import Languages from '../../constants/Languages';
import { getLocalizedUrl } from '../../util/Urls';
import SingleColumnLayout from '../layouts/SingleColumnLayout';
import { ThemedHomePage } from '../../theming/components/ThemedHomePage';
import { useTheme } from 'styled-components';
import { OptOutThemesToggle } from '../../components/OptOutThemesToggle';
import Footer from '../footer/Footer';
import Faq from '../faq/Faq';
import FaqButton from '../faq/FaqButton';
import styled from 'styled-components';
import BottomFaq from '../bottomFaq/BottomFaq';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const languages = Object.keys(Languages);
const Title = () => {
  const theme = useTheme();
  switch (theme.name) {
    case 'halloween':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "home.halloween.title"
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "home.title"
      });
  }
};
const HomePageFormSection = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsxs("h1", {
    className: "title",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "meta.title"
    }), /*#__PURE__*/_jsx("span", {
      className: "registerd-trademark",
      children: /*#__PURE__*/_jsx("sup", {
        children: "\xAE"
      })
    })]
  }), /*#__PURE__*/_jsx("h2", {
    className: "subtitle",
    children: /*#__PURE__*/_jsx(Title, {})
  }), /*#__PURE__*/_jsx(HomepageForm, {})]
});
const ButtonWrapper = styled.div.withConfig({
  displayName: "HomePage__ButtonWrapper"
})(["position:absolute;top:30px;right:30px;display:flex;flex-direction:row;"]);
export default (({
  location,
  match: {
    url
  }
}) => {
  const [faqOpen, setFaqOpen] = useState(false);
  const theme = useTheme();
  useEffect(() => {
    usageTracker.logView('Home', {
      theme: theme.name
    });
  }, []);
  const renderWelcomeBanner = () => {
    switch (location.search) {
      case 'producthunt':
        return /*#__PURE__*/_jsx(AlertMessage, {
          message: "home.productHuntMessage"
        });
      case 'mg':
        return /*#__PURE__*/_jsx(AlertMessage, {
          message: "home.marketingGraderMessage"
        });
      default:
    }
    return undefined;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ThemedHomePage, {
      children: /*#__PURE__*/_jsxs(SingleColumnLayout, {
        className: "home-page",
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "HOME_PAGE_LOADED"
        }), /*#__PURE__*/_jsxs(DocumentHead, {
          children: [/*#__PURE__*/_jsx(Canonical, {
            to: url
          }), /*#__PURE__*/_jsx(Hreflang, {
            href: getLocalizedUrl('en'),
            lang: "x-default"
          }), languages.map(lang => /*#__PURE__*/_jsx(Hreflang, {
            href: getLocalizedUrl(lang),
            lang: lang
          }, lang))]
        }), /*#__PURE__*/_jsxs("div", {
          children: [renderWelcomeBanner(), /*#__PURE__*/_jsxs(ButtonWrapper, {
            children: [/*#__PURE__*/_jsx(LanguageSwitcher, {}), /*#__PURE__*/_jsx(FaqButton, {
              onClick: () => setFaqOpen(true)
            })]
          }), !faqOpen && /*#__PURE__*/_jsx(HomePageFormSection, {})]
        }), /*#__PURE__*/_jsx(Faq, {
          open: faqOpen,
          onClose: () => setFaqOpen(false)
        }), /*#__PURE__*/_jsx(OptOutThemesToggle, {}), /*#__PURE__*/_jsx(Footer, {})]
      })
    }), window.I18N_MANUAL_LANG === 'en' && /*#__PURE__*/_jsx(BottomFaq, {})]
  });
});